import { getHost } from '@utils/api-helper/host';

const defaultHost = getHost();

export const constantsAPIKey = 'v1/constants/?platform=0'; // pragma: allowlist secret

export const fetchConstants = async () =>
  fetch(`${defaultHost}${constantsAPIKey}`).then((res) => res.json());

const fetchIsGoalGTP = async (goalUID, constantsData) => {
  const constants = constantsData || (await fetchConstants());
  const gtpGoalsList = constants.GTP_GOALS || [];
  const isGTP = gtpGoalsList?.includes(goalUID);
  return isGTP;
};

export default fetchIsGoalGTP;
